import React, { Component } from 'react'
import { Analytics } from 'common-frontend'
import { Button } from 'components'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import TextField from 'material-ui/TextField'
import FontIcon from 'material-ui/FontIcon'
import { APP_NAME } from 'consts'

const answers = [
  { label: "I don't understand SEO at all.", value: 'not_at_all' },
  { label: "I understand a few SEO concepts.", value: 'understand_a_few_concepts' },
  { label: "I understand most important SEO concepts.", value: 'understand_important_concepts' },
  { label: "I have a strong understanding of SEO concepts.", value: 'strong_understanding' },
  { label: 'Other', value: 'other' }
]

export default class KeywordsSurvey extends Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = { selected: null, otherReason: '' }
  }

  componentDidMount() {
    Analytics.track('Survey Viewed', {
      email: this.context.currentUser.email,
      survey_type: 'keywords'
    })
  }

  continue() {
    const { selected, otherReason } = this.state

    if (selected) {
      let analyticsBody = {
        email: this.context.currentUser.email,
        survey_type: 'keywords',
        survey_response: selected
      }
      if (selected === 'other' && otherReason) analyticsBody['survey_response_detail'] = otherReason

      Analytics.track('Survey Answered', analyticsBody)
    }

    this.props.commitAction()
  }

  render() {
    return (
      <div className="keywords-survey">
        <div className="keywords-survey__header">
          <h2 className="keywords-survey__title">What is your level of SEO knowledge?</h2>
        </div>

        <div className="keywords-survey__options">
          <RadioButtonGroup name="answer" onChange={(_, value) => this.setState({selected: value})}>
            {answers.map((answer, index) => (
              <RadioButton
                value={answer.value}
                label={<h4>{answer.label}</h4>}
                key={`option-${answer.value}`}
                className="keywords-survey__option"
              />
            ))}
          </RadioButtonGroup>
          {this.state.selected === 'other' && (
            <TextField
              name="other_reason"
              placeholder="What is your level of SEO knowledge?"
              multiLine
              fullWidth
              rowsMax={4}
              value={this.state.otherReason}
              onChange={({ target: { value } }) => this.setState({ otherReason: value })}
            />
          )}
        </div>

        <div className="keywords-survey__footer">
          <Button
            label="View SEO Results"
            buttonType="primary"
            onTouchTap={::this.continue}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checker/KeywordsSurvey.js